var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-wrapper',{attrs:{"isSpinner":_vm.isSpinner}},[_vm._t("default",[_c('CtiDescriptionCommon'),_c('CtiConnectedList',{attrs:{"ctiList":_vm.ctiList}}),_c('CtiFormRequest',{attrs:{"title":_vm.title}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }